import { MARQUEE_ITEMS } from "@/lib/site-data";

const Row = ({ reverse }) => (
  <div className={`marquee-track ${reverse ? "reverse" : ""}`}>
    {[...Array(2)].map((_, dup) => (
      <div key={dup} className="flex items-center">
        {MARQUEE_ITEMS.map((item, i) => (
          <span key={`${dup}-${i}`} className="flex items-center">
            <span className="px-8 font-heading text-4xl font-medium tracking-tight text-white/25 sm:text-5xl md:text-6xl">
              {item}
            </span>
            <span className="text-neon-cyan/60">✦</span>
          </span>
        ))}
      </div>
    ))}
  </div>
);

const Marquee = () => {
  return (
    <section
      data-testid="marquee-section"
      className="relative border-y border-white/10 bg-ink-soft/40 py-10"
      aria-label="What we deliver"
    >
      <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-32 bg-gradient-to-r from-background to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-32 bg-gradient-to-l from-background to-transparent" />
      <Row />
    </section>
  );
};

export default Marquee;
